import React from 'react';
import { IPotentialMatch } from './IPotentialMatch';
import { Form, Formik } from 'formik';
import { IWireForm } from './Forms';
import { IncomingWireValidationSchema } from 'components/order/fees/incomingFunds/IncomingWireDepositValidationSchema';
import { IEscrowExpectedIncomingAchData } from 'types/accounting/data/IEscrowExpectedIncomingAchData';
import { ExpectedSimpleForm } from './ExpectedSimpleForm';

export interface IConfirmWireFormProps {
  potentialMatch: IPotentialMatch;
  createExpected: (x: IWireForm) => void;
  amountCents: number;
  amountCentsMax: number;
}

const achToForm = (achData?: IEscrowExpectedIncomingAchData) => {
  if (!achData) {
    return undefined;
  }
  const { amountCents, category } = achData;
  return { amountCents, category };
};

export const ConfirmWireForm: React.FC<IConfirmWireFormProps> = ({
  potentialMatch,
  createExpected,
  amountCents,
  amountCentsMax,
}) => {
  const initialValueConversion: IWireForm =
    potentialMatch.expectedCheck || achToForm(potentialMatch.expectedACH) || ({ amountCents } as IWireForm);

  const initialValues = {
    ...initialValueConversion,
    version: 'v2-accounting',
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={createExpected}
      validationSchema={IncomingWireValidationSchema({ amountCentsMax })}
    >
      {() => (
        <Form>
          <div className={'text-left text-lg font-semibold'}>Please confirm expected wire information</div>
          <ExpectedSimpleForm />
        </Form>
      )}
    </Formik>
  );
};
